import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController, ToastController, NavController } from '@ionic/angular';
import { PickupDetailsComponent } from 'src/app/modals/pickup-details/pickup-details.component';
import { CartService } from 'src/app/services/cart/cart.service';
import { RetailCartService } from 'src/app/services/retail/retail-cart.service';
import { FoodCartItem, StoreMetaInfo, FoodCart, RetailCartItem, Cart } from 'src/app/models/cart-models';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';
import { Router } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import  *  as  Nationality  from  'src/assets/files/nationality.json';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.page.html',
  styleUrls: ['./checkout.page.scss'],
})
export class CheckoutPage implements OnInit {
  veg = '../../../../../assets/icon/veg.svg';
  nonVeg = '../../../../../assets/icon/nonveg.svg';
  cartItems: FoodCartItem[];
  storeInfo: StoreMetaInfo;
  cart: FoodCart;
  nationalityList: any[];
  totalQuantity: number;
  totalPrice: number;
  discount: number;
  currencyCode: string;
  storeCharges: number;
  paymentByCash: boolean;
  errorMessage: string;
  errorStatus: number;
  timeSlot: string;
  deliveryDate: string;
  type: string;
  route: string;
  routeArr: any;
  userFormError: boolean;
  paymentFormError: boolean;
  showPaymentSection: boolean;
  user: {
    Name: string;
    number: string;
    Email: string;
    passport: string;
    passport_name: string;
    client_name: string;
    program_name: string;
    nationality: string;
    dob: string;
    num_of_co_passangers: number;
    co_passengers: any[];
    asp_case_id: string;
    finalPrice: number;
  };
  flightId: string;
  noData: boolean = false;
  alertMsg: string;
  alertText: string;
  cancelBtn: string;
  continue: string;
  orderPlacing: string;
  datePickerObj: any;
  monthsList: string[];
  weeksList: string[];
  co_passengers: any[];
  asp_fields: boolean;
  isValidToCheckout: boolean;
  validationError: string;
  locationId: number;
  // tslint:disable-next-line: max-line-length
  constructor(private seoService: SeoService, private modalController: ModalController, private cartService: CartService, private alertController: AlertController, private loaderService: LoaderService, private toastController: ToastController, private navControl: NavController, private i18ConfigService: I18ConfigService, private router: Router, private retailCartService: RetailCartService,private translate: TranslateService, private datePipe: DatePipe) {
    this.initCheckoutState();
    this.currencyCode = i18ConfigService.getCurrency();
  }

  initCheckoutState() {
    this.storeInfo = {} as StoreMetaInfo;
    this.cartItems = [];
    this.asp_fields = false;
    this.co_passengers = [];
    this.cart = {} as FoodCart;
    this.storeCharges = 0;
    this.discount = 0;
    this.errorMessage = null;
    this.userFormError = false;
    this.paymentFormError = false;
    this.showPaymentSection = true;
    this.isValidToCheckout = true;
    if(localStorage.getItem("pid") == "asp"){
      this.isValidToCheckout = false;
      this.showPaymentSection = false;
      this.paymentByCash = true;
      this.asp_fields = true;
      this.nationalityList = [];
      this.nationalityList = Nationality.map(obj => ({...obj}));
    }
    this.validationError = '';
    this.user = { Name: '', number: '', Email: '', passport: '', passport_name: '', dob: '', nationality: 'Indian', num_of_co_passangers: 0, client_name: 'HSBC', program_name: '', co_passengers: [], asp_case_id: '', finalPrice: 0 };
    this.errorStatus = null;
    this.initializeCalenderUIState();
  }

  initializeCalenderUIState() {
    const date = new Date();
    let date_string  = this.datePipe.transform(date, 'dd MMM yyyy');
    // Initializing Date Picker Properties
    this.monthsList = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    this.weeksList = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

    /*     const disabledDates: Date[] = [
      new Date(1545911005644),
      new Date(),
      new Date(2018, 12, 12), // Months are 0-based, this is August, 10th.
      new Date('Wednesday, December 26, 2018'), // Works with any valid Date formats like long format
      new Date('12-14-2018') // Short format
    ]; */
    // reference URL https://www.logisticinfotech.com/blog/ionic4-datepicker-component/
    this.datePickerObj = {
      // inputDate: new Date('12'), // If you want to set month in date-picker
      // inputDate: new Date('2018'), // If you want to set year in date-picker
      // inputDate: new Date('2018-12'), // If you want to set year & month in date-picker
      // inputDate: new Date('2018-12-01'), // If you want to set date in date-picker

      // fromDate: date_string, // need this in order to have toDate
      toDate: date_string,
      // showTodayButton: false,
      closeOnSelect: true,
      // disableWeekDays: [],
      // mondayFirst: true,
      // setLabel: 'Select a Date',
      // todayLabel: 'Today',
      // closeLabel: 'Close',
      // disabledDates: [],
      titleLabel: 'Select a Date',
      // monthsList: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      // weeksList: ['S', 'S', 'M', 'T', 'W', 'T', 'F'],
      // dateFormat: 'MMMM D, YYYY',
      clearButton: false,
      showTodayButton: false,
      // momentLocale: 'pt-BR',
      // yearInAscending: true,
      // btnCloseSetInReverse: false,

      btnProperties: {
        expand: 'block', // 'block' | 'full'
        fill: '', // 'clear' | 'default' | 'outline' | 'solid'
        size: '', // 'default' | 'large' | 'small'
        // disabled: 'true', // boolean (default false)
        strong: '', // boolean (default false)
        color: '#ffffff'
        // 'primary', 'secondary', 'tertiary', 'success', 'warning', 'danger', 'light', 'medium', 'dark' , and give color in string
      }
    };
  }
  ngOnInit() {
    // console.log('checkout screen onnginit');
  }

  async validateCart(){
    let err_msg = ''
    let max_cartPrice = 0;
    let max_liquor = 0;
    let totalLiquorInCart = 0;
    // For detecting Arrival & Departure conditions for Delhi Duty Free
    if(this.locationId == 5261){
      max_cartPrice = 25000 + (this.user.num_of_co_passangers * 25000)
      max_liquor = 2000 + (this.user.num_of_co_passangers * 2000)
    }
    if(this.locationId == 5262){
      max_cartPrice = 200000 + (this.user.num_of_co_passangers * 200000)
      max_liquor = 5000 + (this.user.num_of_co_passangers * 5000)
    }
    
    this.cartItems.forEach((element, index) => {
      if(element.breadcrumbsStore.includes("liquor")){
        let size = element.size.replace("ml", ""); 
        totalLiquorInCart += (parseInt(size) * element.quantity);
      }
    });

    if(this.totalPrice > max_cartPrice){
      if(this.locationId == 5261){ //arrival
        err_msg = 'Your total passport(s) shopping limit is ₹25000'
      }
      if(this.locationId == 5262){ //departure
        err_msg = 'Your total passport(s) shopping limit is ₹200000'
      }
    }

    if(totalLiquorInCart > max_liquor){ //if liquor quantity is greater than n lits
      if(this.locationId == 5261){
        err_msg = "Your total passport(s) Liquor qunatity is 2 ltr."
      }
      if(this.locationId == 5262){
        err_msg = "Your total passport(s) Liquor qunatity is 5 ltr."
      }
    }

    if(totalLiquorInCart > max_liquor && this.totalPrice > max_cartPrice){ //if liquor quantity is greater than n lits
      if(this.locationId == 5261){
        err_msg = "Your total passport(s) shopping limit is ₹25000 and Liquor qunatity is 2 ltr."
      }
      if(this.locationId == 5262){
        err_msg = "Your total passport(s) shopping limit is ₹200000 and Liquor qunatity is 5 ltr."
      }
    }

    if(err_msg != ''){
      this.isValidToCheckout = false;
      const alert = await this.alertController.create({
          header: 'Alert!',
          message: err_msg,
          buttons: [
            {
              text: 'Okay',
              role: 'cancel',
              cssClass: 'primary',
              handler: (blah) => {
                // console.log('Confirm Cancel:', blah);
  
              }
            }
          ]
      });
      alert.present();
    }else{
      this.isValidToCheckout = true;
    }
  
  }

  co_counter(n: any) {
    n = parseInt(n);
    this.user.co_passengers = [];
    for(let i=0; i < n; i++){
      let user = {
        name: '',
        passport: '',
        dob: '',
        err_msg: '',
      }
      this.user.co_passengers.push(user);
    }
    this.validateCart();
  }

  ionViewWillEnter() {
    this.initCheckoutState();
    this.renderCartData();
  }

  async presentPickupDetailsModal(storeId: number, locationId: number) {
    const modal = await this.modalController.create({
      component: PickupDetailsComponent,
      backdropDismiss: false,
      componentProps: {
        storeId: this.cart.storeId,
        locationId: this.cart.locationId
      }
    });
    modal.onDidDismiss().then((response) => {
      if (response.data && response.data.validationResults) {
        this.errorMessage = response.data.validationResults.message;
        this.errorStatus = response.data.validationResults.status_code;
        this.timeSlot = response.data.timeSlot;
        this.flightId = response.data.flightId;
        this.deliveryDate = response.data.date;
      }

      if(localStorage.getItem("pid") == "asp"){
        this.errorMessage = '';
        this.errorStatus = 0;
        this.timeSlot = localStorage.getItem("pickup_time");
        this.flightId = localStorage.getItem("flight_id");
        this.deliveryDate =  localStorage.getItem("flight_date");
      }
    });

    return await modal.present();

  }

  validateEmail (emailAdress)
  {
    let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (emailAdress.match(regexEmail)) {
      return true; 
    } else {
      this.validationError = "Please enter valid email";
      this.userFormError = false;
      return false; 
    }
  }
  
  validatePhone (phone){
    if(phone.toString().length != 10){
      this.validationError = "Please enter valid phone";
      this.userFormError = false;
      return false;
    }else{
      return true;
    }
  }

  calculateAge(dateString) {
    var birthday = +new Date(dateString);
    let date =  ~~((Date.now() - birthday) / (31557600000));
    if(date < 25){
      this.validationError = "Age should be more than 25 years.";
      this.userFormError = false;
      return false;
    }else{      
      return true;
    }
  }

  validateCoPassengers(){
    let error = false;
    let arr = [];
    this.user.co_passengers.forEach((element, index) => {
      if(element.name && element.dob && element.passport && this.calculateAge(element.dob)){
        if(this.user.passport == element.passport){
          element.err_msg = 'Passport Numbers must be different';
          error = true;
        }else{
          if(arr.includes(element.passport)){
            element.err_msg = 'Passport Numbers must be different';
            error = true;
          }else{
            arr.push(element.passport);
            element.err_msg = '';
            error = false;
          }
        }
      }else{
        element.err_msg = 'All fields mandatory and age should be more than 25 years';
        error = true;
      }
    });
    if(error){
      return false;
    }else{
      return true;
    }
  }

  compareWithClientName = (o1, o2) => {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  };


  placeOrder() {
    let condition1 = this.user.Email && this.user.Name && this.user.number
    let condition2 = this.validateEmail(this.user.Email) && this.validatePhone(this.user.number)
    if(this.asp_fields){
      condition1 = this.user.Email && this.user.Name && this.user.number && this.user.passport && this.user.passport_name && this.user.client_name && this.user.program_name && this.user.nationality && this.user.dob

      condition2 = this.validateEmail(this.user.Email) && this.validatePhone(this.user.number) && this.calculateAge(this.user.dob) && this.validateCoPassengers()
    }
    this.translate.get('ALERT.order_placing', {value: 'world'}).subscribe((res: string) => {
      this.orderPlacing = res;
    });
    if (this.errorStatus !== null) {
      if (condition1) {
        if(condition2){
          this.validationError = '';
        if (!this.paymentByCash) {
          this.paymentFormError = true;
        } else {

          if (this.errorStatus && this.errorMessage) {
            this.presentGoToCartAlert();
          } else {
            this.loaderService.presentLoading(this.orderPlacing);
            if (this.type === 'food') {
              this.cartService.checkoutCart(this.user).toPromise().then((response) => {
                if (response.orderDetails && response.orderDetails.orderId) {
                  this.loaderService.loading.dismiss();
                  this.cartService.clearFoodCart();
                  localStorage.setItem('userId', response.userId);
                  localStorage.removeItem('guestId');
                  this.navControl.navigateRoot(['shopping/food/checkout/confirmed'], { queryParams: { orderId: response.orderDetails.orderId } });
                  // this.router.navigate(['shopping/food/checkout/confirmed'], { queryParams: { orderId: response.orderDetails.orderId } });
                } else {
                  this.loaderService.loading.dismiss();
                  this.presentToast('Something went wrong, please try again!');
                }
              }).catch((e) => {
                this.loaderService.loading.dismiss();
                this.presentToast('Something went wrong, please try again!');
              });
              // tslint:disable-next-line: triple-equals
            } else if (this.type == 'retail') {
              if(localStorage.getItem("pid") == "asp"){
                this.user.finalPrice = this.totalPrice
              }
              this.retailCartService.checkoutCart(this.user, this.cartItems).toPromise().then((response) => {
                if (response.orderDetails && response.orderDetails[0].orderId) {
                  let orderId = response.orderDetails[0].orderId;
                  this.loaderService.loading.dismiss();
                  this.navControl.navigateRoot(['shopping/retail/checkout/confirmed'], { queryParams: { orderId: response.orderDetails.orderId } });
                  // this.router.navigate(['shopping/food/checkout/confirmed'], { queryParams: { orderId: response.orderDetails.orderId } });
                  if (localStorage.getItem("pid") == "asp") {
                    window.location.href = "https://dash.travelx.ai/user_orders/show/" + orderId;
                  }
                } else {
                  this.loaderService.loading.dismiss();
                  this.presentToast('Something went wrong, please try again!');
                }
              }).catch((e) => {
                this.loaderService.loading.dismiss();
                this.presentToast('Something went wrong, please try again!');
              });
            }
          }
        }
        }
      } else {
        this.userFormError = true;
      }
    } else {
      this.presentToast('Please add pickup date time.');
    }
  }
  async presentToast(msg: string) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'top',
      buttons: [
        {
          // text: 'Done',
          icon: 'close',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          }
        }
      ]
    });
    toast.present();
  }

  async presentGoToCartAlert() {
    this.translate.get('ALERT.title', {value: 'world'}).subscribe((res: string) => {
      this.alertMsg = res;
    });
    this.translate.get('ALERT.text', {value: 'world'}).subscribe((res: string) => {
      this.alertText = res;
    });
    this.translate.get('ALERT.cancel_btn', {value: 'world'}).subscribe((res: string) => {
      this.cancelBtn = res;
    });
    this.translate.get('ALERT.continue', {value: 'world'}).subscribe((res: string) => {
      this.continue = res;
    });
    this.translate.get('ALERT.order_placing', {value: 'world'}).subscribe((res: string) => {
      this.orderPlacing = res;
    });
    const alert = await this.alertController.create({
      header: this.alertMsg,
      message: this.alertText,
      buttons: [
        {
          text: this.cancelBtn,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            // console.log('Confirm Cancel:', blah);
          }
        }, {
          text: this.continue,
          handler: () => {
            this.loaderService.presentLoading(this.orderPlacing);
            if (this.type === 'food') {
              this.cartService.checkoutCart(this.user).toPromise().then((response) => {
                this.loaderService.loading.dismiss();
                this.navControl.navigateRoot(['shopping/food/checkout/confirmed'], { queryParams: { orderId: response.orderDetails.orderId } });
              });
            } else if (this.type === 'retail') {
              this.retailCartService.checkoutCart(this.user, this.cartItems).toPromise().then((response) => {
                if (response.orderDetails && response.orderDetails[0].orderId) {
                  let orderId = response.orderDetails[0].orderId;
                  this.loaderService.loading.dismiss();
                  this.navControl.navigateRoot(['shopping/retail/checkout/confirmed'], { queryParams: { orderId: response.orderDetails.orderId } });
                  if (localStorage.getItem("pid") == "asp") {
                    window.location.href = "https://dash.travelx.ai/user_orders/show/" + orderId;
                  }
                }
              });
            }
            // this.ngZone.run(() => this.router.navigate(['shopping/food/cart']));
          }
        }
      ]
    });

    await alert.present();
  }

  renderCartData() {
    this.route = this.router.url;
    this.routeArr = this.route.split('/');
    this.type = this.routeArr[2];
    this.seoService.updatePageTitle('checkout|' + this.type);
    this.cartService.getCartList(this.type).subscribe(response => {
      if (!response.location_id || !response.storeMetaInfo) {
        return this.noData = true;
      }
      this.storeInfo = response.storeMetaInfo || {} as StoreMetaInfo;
      if (this.type === 'food') {
        this.cartItems = response.cartlist || [] as FoodCartItem[];
        this.cart.list = [...this.cartItems];
      } else {
        this.cartItems = response.productList || [] as RetailCartItem[];
      }
      // console.log(this.storeInfo.id);
      // console.log(response.);
      this.updateCartParams();
      this.cart.storeId = this.storeInfo.id;
      this.cart.locationId = response.location_id;
      this.locationId = response.location_id;
      this.cartService.foodCart = this.cart;
      if (this.storeInfo.id && response.location_id) {
        this.presentPickupDetailsModal(this.storeInfo.id, response.location_id);
      } else {
        // show Empty Screen
      }
      if(this.asp_fields){
        this.validateCart();
      }
    });
  }
  updateCartParams() {
    this.totalQuantity = 0;
    this.totalPrice = 0;
    this.cartItems.forEach((element) => {
      this.totalQuantity += element.quantity;
      this.totalPrice += (element.price * element.quantity);
    });

    if(localStorage.getItem("pid") == "asp"){
      this.totalPrice = parseInt(localStorage.getItem("finalPrice"));
      this.discount = parseInt(localStorage.getItem("discount"));
    }
  }

}
